import { usePagination } from 'react-instantsearch-hooks-web';

import styles from './Pagination.module.scss'

export const Pagination = (props) => {

    const { isLastPage, isFirstPage, currentRefinement, refine } = usePagination(props);

    return (
        <div className={styles.container}>

            {isFirstPage ? null :
            
            <div className={styles.navButton} 
             onClick={(event) => {
                event.preventDefault();
                refine(currentRefinement - 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
             }}>Previous</div>
               
            }

            {isLastPage ? null :

            <div className={styles.navButton} 
             onClick={(event) => {
                event.preventDefault();
                refine(currentRefinement + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }}>Next</div>

           }
       
        </div>
      );

}